//@ts-nocheck
import { useState } from 'react';
import type { NextPage } from 'next';
import Link from 'next/link';
import Image from 'next/image';
import Layout from '@components/Layout';
import {
  GlobalStyle,
  ModalBaileys,
  BailetsBlock,
  MenuWrap
} from './ModalLadyBailey.styles';
import { CloseVideoIcon, LogoMansion, LogoMartins } from '@assets/svgs';
import Footer from '@components/Footer';
import couture1 from '@assets/couture_1.png';
import couture2 from '@assets/couture_2.png';
import { Plans } from './data/Plans';
import { Smiling_Face_with_Smiling_eyes } from '@assets/emojis';

type ReadProps = {
  showHChighlight?: boolean;
  isClosed?: () => void;
};

const LadyBaileymodal = ({ showHChighlight, isClosed }: ReadProps) => {
  return (
    <>
      <GlobalStyle />
      <Layout showHeader showNoheader showMenu showTheStoryHeader>
        <ModalBaileys>
          <section>
            <BailetsBlock>
              <CloseVideoIcon
                animation="closeIcon"
                color="#000"
                isActive={isClosed}
              />
              <LogoMartins
                width={70}
                height={65}
                color="rgba(0,0,0,0.5)"
                animation="mansion"
              />

              <h3>TRENDS & COUTURE</h3>
              <span>Atlier COUTURE & CREATIVITY</span>
              <p style={{ padding: '0' }}>
                Women in this century embody sophistication and dignity. It is
                crucial to know when and how to be sophisticated, but it is
                equally important to maintain dignity at all times. The trends &
                couture section aims to guide you in redesigning yourself and
                becoming the woman you aspire to be. The ability to reinvent
                your persona is the magic that you possess, waiting to be
                unleashed. Dare to live your imagination and be the best version
                of yourself.
                <br />
                <br />
                If you seek a thorough understanding of the section and its
                workings before selecting any of the plans, feel free to reach
                out to us via{' '}
                <Link
                  href={`mailto:baileysmansion@jorgedd.com?subject=Trends and Couture Information&body=Hello there,%0D%0A%0D%0AMy name's [ Your name here ] and I am from [ your country and/or your city here ].%0D%0AI'm interested in choosing one of your plans, but I would like to have some more detailed information about it.%0D%0A%0D%0AThis is the plan I would like to go to, [ Name of the plan ].%0D%0A%0D%0AI would like to have this information as soon as possible, please.%0D%0A%0D%0A%0D%0AMy Contacts:%0D%0A%0D%0AMy number: [ Your phone number(This information is optional) ]%0D%0AMy email address: [ Your email address here ]%0D%0A%0D%0A%0D%0A%0D%0A%0D%0A%0D%0A%0D%0A%0D%0AThank you very much,%0D%0A[ Your name here ]`}
                  style={{ textDecoration: 'underline', color: '#000' }}
                >
                  <b>Email</b>
                </Link>{' '}
                or{' '}
                <Link
                  href={`https://api.whatsapp.com/send?phone=+447502816932&text=Hello There,%0a%0aMy name is:%0aI am from:%0a%0aI'm interested in choosing one of your plans, but I would like to have some more detailed information about it.%0aThis is the plan I would like to go to: [ Name of the plan ]%0a%0aI would like to have this information as soon as possible, please.%0a%0aMy number:%0aMy email address:%0a%0aThank you vey much,%0a[ Your name here ]`}
                  style={{ textDecoration: 'underline', color: '#000' }}
                >
                  <b>WhatsApp</b>
                </Link>
                . We're always here to help you make informed decisions that
                will shape your future.
              </p>
            </BailetsBlock>
            <BailetsBlock style={{ justifyContent: 'center' }}>
              <span>One</span>
              <h2>RENEW YOUR WARDROBE FOR MODERNITY </h2>
              <span style={{ marginBottom: '25px' }}>Ready-To-Wear</span>

              <p style={{ padding: '0' }}>
                Take the first step and let us lead you towards success. Success
                is defined by your determination and strength to make your
                dreams a reality. Create a wardrobe that reflects your
                imagination and becomes the star of your world. Dare to dream
                big and let your aspirations soar. You are a powerful and
                confident woman who can achieve anything.
              </p>
              <br />
              <Image src={couture1} width={1785} height={997} alt="Couture 1" />
              <h4 className="h4Top">TAKE A LOOK ON OUR PLANS</h4>
              <h4>WE CREATED SPECIALLY FOR YOU</h4>

              <Plans readyPlan mWidth="435px" />
            </BailetsBlock>

            <BailetsBlock style={{ justifyContent: 'center' }}>
              <span>TWO</span>
              <h2>HOW TO CREATE YOUR EVENING COLLECTION?</h2>
              <span style={{ marginBottom: '25px' }}>
                HIgh Fashion - Haute Couture
              </span>

              <p style={{ padding: '0' }}>
                Evenings are wonderful when we decide to go out in the right
                evening dress, jumpsuit or even wearing a blazer-dress. Let your
                body talk to yourself, design the most beautiful evening outfit
                and show off the amazing queen in you. Reinvent the trend you
                think will change the moon and the constellation of your magical
                soul.
              </p>
              <br />
              <br />
              <Image src={couture2} width={1785} height={997} alt="Couture 2" />
              <h4 className="h4Top">TAKE A LOOK ON OUR PLAN</h4>
              <h4>FOR YOUR EVENING WEAR</h4>

              <Plans eveningPlan mWidth="518px" />
            </BailetsBlock>

            <Footer mgT="40px" />
          </section>
        </ModalBaileys>
      </Layout>
    </>
  );
};

export default LadyBaileymodal;
